import { render, staticRenderFns } from "./AgentInfomation.vue?vue&type=template&id=2bdd8749&scoped=true&"
import script from "./AgentInfomation.vue?vue&type=script&lang=js&"
export * from "./AgentInfomation.vue?vue&type=script&lang=js&"
import style0 from "./AgentInfomation.vue?vue&type=style&index=0&id=2bdd8749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd8749",
  null
  
)

export default component.exports